
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTopBar as ObcTopBarElement} from '@oicl/openbridge-webcomponents/dist/components/top-bar/top-bar.js';
 import {BreadcrumbClickEvent} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
 export type {BreadcrumbClickEvent} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
 

 
 export const ObcTopBar = createComponent({
   react: React,
   tagName: 'obc-top-bar',
   elementClass: ObcTopBarElement,
   events: {
     
     onMenuButtonClicked: 'menu-button-clicked' as EventName<CustomEvent<unknown>>,
     onDimmingButtonClicked: 'dimming-button-clicked' as EventName<CustomEvent<unknown>>,
     onAppsButtonClicked: 'apps-button-clicked' as EventName<CustomEvent<unknown>>,
     onLeftMoreButtonClicked: 'left-more-button-clicked' as EventName<CustomEvent<unknown>>,
     onUserButtonClicked: 'user-button-clicked' as EventName<CustomEvent<unknown>>,
     onClose: 'close' as EventName<CustomEvent<unknown>>,
     onBack: 'back' as EventName<CustomEvent<unknown>>,
     onEmergencyBrightnessStart: 'emergency-brightness-start' as EventName<CustomEvent<unknown>>,
     onEmergencyBrightnessStop: 'emergency-brightness-stop' as EventName<CustomEvent<unknown>>,
     onBreadcrumbClick: 'breadcrumb-click' as EventName<BreadcrumbClickEvent>,
   }
  });
 
 